import React from 'react';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { Link } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth } from '../firebase';
import { Button } from 'react-bootstrap';

function NavbarComponent({ isAuth, setIsAuth, isAdmin, setIsAdmin }) {
  const userSignout = () => {
    signOut(auth).then(() => {
      localStorage.removeItem("isAuth");
      setIsAuth(false);
      setIsAdmin(false);
    });
  }
  return (
    <>
      <Navbar 
        expand="lg" 
        style={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center',
          padding: '18px 0',
          backdropFilter: 'blur(10px)',
          backgroundColor: 'rgba(255, 255, 255, 0.8)',
          boxShadow: '0 2px 10px rgba(0, 0, 0, 0.05)',
          position: 'sticky',
          top: 0,
          zIndex: 1000,
          borderBottom: '1px solid rgba(0, 0, 0, 0.05)'
        }}
      >
        <Container>
            <Link 
              to="/" 
              style={{ 
                fontWeight: '800', 
                textDecoration: 'none', 
                fontSize: '28px', 
                color:'inherit',
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                letterSpacing: '-0.5px'
              }}
            >
              Subin's StoryBoard
            </Link>
          <Navbar.Toggle aria-controls="navbar-nav" block="true" />
          <Navbar.Collapse id="navbar-nav">
            <Nav className="ms-auto" style={{fontSize: '17px', gap: '10px', alignItems: 'center'}}>
              <Nav.Item>
                <Link 
                  to="/" 
                  className="nav-link" 
                  style={{ 
                    fontWeight: '600', 
                    textDecoration: 'none', 
                    color: 'inherit',
                    padding: '8px 16px',
                    borderRadius: '8px',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseEnter={(e) => e.target.style.background = 'rgba(102, 126, 234, 0.1)'}
                  onMouseLeave={(e) => e.target.style.background = 'transparent'}
                >
                  Home
                </Link>
              </Nav.Item>
              <Nav.Item>
                <Link 
                  to="/profile" 
                  className="nav-link" 
                  style={{ 
                    fontWeight: '600', 
                    textDecoration: 'none', 
                    color: 'inherit',
                    padding: '8px 16px',
                    borderRadius: '8px',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseEnter={(e) => e.target.style.background = 'rgba(102, 126, 234, 0.1)'}
                  onMouseLeave={(e) => e.target.style.background = 'transparent'}
                >
                  Profile
                </Link>
              </Nav.Item>
            {isAuth && isAdmin && <Nav.Item>
                 <Link 
                   to="/admin" 
                   className="nav-link" 
                   style={{ 
                     fontWeight: '600', 
                     textDecoration: 'none', 
                     color: 'inherit',
                     padding: '8px 16px',
                     borderRadius: '8px',
                     transition: 'all 0.3s ease'
                   }}
                   onMouseEnter={(e) => e.target.style.background = 'rgba(102, 126, 234, 0.1)'}
                   onMouseLeave={(e) => e.target.style.background = 'transparent'}
                 >
                   Admin
                 </Link>
              </Nav.Item>}
              <Nav.Item>
                {isAuth ? (
                  <Button 
                    onClick={userSignout} 
                    variant="link" 
                    style={{ 
                      color: 'inherit', 
                      fontWeight: '600', 
                      textDecoration: 'none', 
                      padding: '8px 20px',
                      borderRadius: '8px',
                      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                      border: 'none',
                      transition: 'all 0.3s ease'
                    }}
                    onMouseEnter={(e) => e.target.style.transform = 'translateY(-2px)'}
                    onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}
                  >
                    Logout
                  </Button>
                ) : (
                  <Link 
                    to="/login" 
                    className="nav-link" 
                    style={{ 
                      fontWeight: '600', 
                      textDecoration: 'none', 
                      padding: '8px 20px',
                      borderRadius: '8px',
                      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                      color: 'white',
                      transition: 'all 0.3s ease'
                    }}
                    onMouseEnter={(e) => e.target.style.transform = 'translateY(-2px)'}
                    onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}
                  >
                    Login
                  </Link>
                )}
              </Nav.Item>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
}

export default NavbarComponent;
